import React from "react";
import type { GatsbyBrowser } from "gatsby";
import AuthProvider from "./src/auth/AuthProvider";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => {
  return <AuthProvider>{element}</AuthProvider>;
};
